export default __webpack_public_path__ + "static/media/division-2.b6470440.png";